<template>
  <div>
    <p class="detail-title">{{lang[0]}}</p>
    <div class="text-center">
      <btn type="primary" size="normal" :label="lang[3]" @click="openReceived"></btn>
    </div>
    <modal v-if="modalReceived" @close="close">
      <p class="text-center detail-title">{{lang[1]}}</p>
      <p class="text-center detail-text">{{lang[2]}}</p>
      <div class="m-t-20 text-center space-around">
        <btn type="cancel" size="normal" :label="lang[4]" @click="close()"></btn>
        <btn type="primary" size="normal" :label="lang[3]" @click="sendNextPhaseEvent(decideVal.id, decideVal.saler_id)" :loading="loading"></btn>
      </div>
    </modal>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>
import Modal from '../components/Modal.vue'
import Btn from '../components/Button.vue'
import notice from '../components/Notice.vue'
import errHandling from '../mixins/apiErrorHandle.js'
import axios from 'axios'
import RequestPhase5LangMaster from '../masters/langMaster/RequestPhase5LangMaster'

export default {
  name: 'RequestPhase5',

  components:{
      Modal,
      Btn
  },

  mixins: [errHandling],

  props:[
    'loading',
    'recieved',
    'request',
    'decideVal',
    'decideUser',
  ],

  data() {
    return {
      modalReceived: this.recieved,
      lang: RequestPhase5LangMaster[this.$store.state.account.lang],
      loading: false,
      noticeTitle: '',
      noticeText: '',
      noticeType: '',
      isNotice: false,
    }
  },

  methods:{
    close() {
      this.$parent.isPurchase = false
      this.$parent.isSendIdea = false
      this.$parent.isIdeaCheck = false
      this.$parent.confirm = false
      this.$parent.confirmShipped = false
      this.modalReceived = false
      this.$parent.isEvaluation = false
      this.$parent.previewModal = false
      setTimeout(this.$parent.isNotice = false ,5000)
    },

    openReceived() {
      this.modalReceived = true
    },

    sendNextPhaseEvent(ideaId, salerId) {
      this.loading = true
      axios.post(`/private/trade/recieve`, {
        buyer_id: this.$store.state.account.id,
        request_id: this.$route.params.id,
        idea_id: ideaId,
        saler_id: salerId,
        type: 0,
      })
      .then(data => {
        this.$emit('recieve')
        this.loading = false
      }).catch(err => {
        this.errorHandling(err)
        console.log(err)
      })
    },
  }
}
</script>

<style scoped>

  .m-t-20 {
    margin-top: 20px;
  }

  .detail-text{
    font-size: 12px;
  }

  .space-around {
    justify-content: space-around;
    display: flex;
  }

@media screen and (min-width: 800px){

  .detail-title {
    font-size: 18px;
  }
}
</style>
